// extracted by mini-css-extract-plugin
export default {"ordersMap":"orders-map_ordersMap__hGRy1","ordersMapContainer":"orders-map_ordersMapContainer__Rwjmi"};